import React, { Fragment, useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { formatDbDateWithoutTime } from '../../utils/dateFormater';
import { UpdateStatusAction } from '../../redux/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../loader/loader';
import DefaultAvatar from "../images/default_avatar.jpg"
import HoverFullText from '../../elements/HoverToolKit';
import AproveUser from './AproveUser';

const SingleAdmin = ({ PMM, index, page = 1, perPage = 20, user }) => {

    const [showPopup, setShowPopup] = useState(false);
    const [showApproval, setShowApproval] = useState(false);
    const [actionToPerform, setActionToPerform] = useState("");
    const [popupHeading, setPopupHeading] = useState("");
    const [popupPara, setPopupPara] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const dispatch = useDispatch()

    const { loading } = useSelector(state => state.inviteUser)

    const displayIndex = String((Number(page) - 1) * Number(perPage) + index + 1).padStart(2, '0');
    const phoneNumber = [PMM?.country_code, PMM?.phone_number].filter(Boolean).join(" ");

    const handleUpdateStatus = (userId, UserStatus) => {
        let userData = {
            id: userId,
            status: UserStatus
        }
        dispatch(UpdateStatusAction(userData));
    }

    return (
        <Fragment>
            {loading && <Loader />}
            <div className="flex flex-col min-w-[1400px] border border-zinc-100 border-l-4 border-l-indigo-600 bg-white rounded-r-xl rounded-l-md hover:shadow-md transition-all mb-[1vmax] relative" >
                {Number(PMM?.active_reports_count) > 0 &&
                    <div className={`absolute top-0 left-0 text-[1.2vmax] lg:text-[0.75vmax] font-jakarta font-bold p-[0.3vmax_1vmax] 
                        ${Number(PMM?.active_reports_count) > 20 ? "bg-red-500" : 
                          Number(PMM?.active_reports_count) > 10 ? "bg-orange-400" : "bg-emerald-500"} 
                        text-white rounded-br-lg`}
                    >
                        {PMM?.active_reports_count} Active Report(s)
                    </div>
                }
                
                {/* Top Section: Details */}
                <div className="flex py-[1.2vmax] items-center">
                    <div className="text-center flex-[0.4] text-zinc-400 font-jakarta font-bold text-[1.5vmax] lg:text-[0.9vmax]" >
                        {displayIndex}
                    </div>
                    <div className="px-[1vmax] flex-[1.2] flex gap-[1vmax] items-center" >
                        <div className="w-[4vmax] h-[4vmax] lg:w-[2vmax] lg:h-[2vmax]" >
                            <img src={PMM?.avatar_url || DefaultAvatar} alt="" className="w-full h-full rounded-full border border-zinc-100" />
                        </div>
                        <span className="text-zinc-800 font-jakarta font-bold text-[1.6vmax] lg:text-[0.85vmax]" >{PMM?.name}</span>
                    </div>
                    <div className="px-[1vmax] flex-[2] flex items-center" >
                        <span className="text-zinc-500 font-jakarta text-[1.5vmax] lg:text-[0.8vmax] lowercase" >
                            <HoverFullText text={PMM?.email} sliceLength={20} />
                        </span>
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[1.2] text-gray-700 font-semibold text-[1.6vmax] lg:text-[0.85vmax]" >
                        {phoneNumber ? <HoverFullText text={phoneNumber} sliceLength={14} /> : "N/A"}
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[0.8] text-gray-700 font-medium text-[1.5vmax] lg:text-[0.9vmax]" >
                        <span className={`px-[1vmax] py-[0.3vmax] rounded-full text-[1.4vmax] lg:text-[0.8vmax] font-bold uppercase tracking-wider bg-gray-50 text-gray-600`}>
                            {PMM?.role || "N/A"}
                        </span>
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[0.8] text-gray-700 font-bold text-[1.5vmax] lg:text-[0.9vmax]" >
                        {PMM?.role === "PMM" ? 
                            String(PMM?.pmm_id).padStart(2, '0') || "000"  
                            : PMM?.id || 0}
                    </div>

                    <div className="flex flex-col items-center justify-center text-center px-[0.5vmax] flex-[1.2] text-gray-700 text-[1.5vmax] lg:text-[0.9vmax]" >
                        <span className="font-bold text-gray-800">
                            <HoverFullText text={PMM?.referal_name || "N/A"} sliceLength={12} />
                        </span>
                        {PMM?.refered_by && (
                            <span className="text-gray-400 text-[1.2vmax] lg:text-[0.8vmax]">ID: {PMM?.refered_by}</span>
                        )}
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[1] text-gray-700 font-medium text-[1.5vmax] lg:text-[0.9vmax]" >
                        {formatDbDateWithoutTime(PMM?.created_at)}
                    </div>

                    <div className="flex justify-center flex-[3] items-center relative" ref={dropdownRef}>
                        <button 
                            onClick={() => setShowDropdown(!showDropdown)}
                            className={`px-[1.5vmax] py-[0.6vmax] rounded-lg text-[1.4vmax] lg:text-[0.75vmax] font-bold transition-colors text-white flex items-center gap-1 
                                ${PMM?.status === "ACTIVE" ? "bg-emerald-600 hover:bg-emerald-700" :
                                  PMM?.status === "BLOCKED" ? "bg-rose-600 hover:bg-rose-700" : 
                                  "bg-amber-600 hover:bg-amber-700"}`}
                        >
                            {PMM?.status === "ACTIVE" ? "Active" :
                             PMM?.status === "BLOCKED" ? "Blocked" : 
                             PMM?.status === "TEMPORARILY_BLOCKED" ? "Temp Blocked" : "Pending"}
                            <i className="fa-solid fa-chevron-down text-[1.2vmax] lg:text-xs"></i>
                        </button>
                        
                        {showDropdown && (
                            <div className="absolute right-0 top-full mt-1 w-[220px] lg:w-[170px] bg-white border border-gray-100 shadow-lg rounded-lg z-[10] overflow-hidden">
                                <Link 
                                    to={`/dashboard/user-details?user_id=${PMM?.id}`} 
                                    className="flex items-center w-full text-left px-5 py-3 lg:px-4 lg:py-2 text-[1.4vmax] lg:text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium"
                                    onClick={() => setShowDropdown(false)}
                                >
                                    <i className="fa-regular fa-eye mr-2 w-4"></i> View Details
                                </Link>
                                
                                <button 
                                    className={`flex items-center w-full text-left px-5 py-3 lg:px-4 lg:py-2 text-[1.4vmax] lg:text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium ${PMM?.status === "BLOCKED" ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={PMM?.status === "BLOCKED"}
                                    onClick={() => {
                                        setShowDropdown(false)
                                        setShowPopup(true)
                                        setActionToPerform("BLOCKED")
                                        setPopupHeading(`Block ${PMM.name}`)
                                        setPopupPara(PMM?.products_count > 0 ?
                                            `This PMM has ${PMM.products_count || 0} products and pending orders. Blocking this user will cancel unfinished products and all orders currently in process. Do you want to continue?` 
                                            : `Are you sure you want to block ${PMM.name}?`)
                                    }}
                                >
                                    <i className="fa-solid fa-user-slash mr-2 w-4"></i> Block Permanently
                                </button>
                                
                                <button 
                                    className={`flex items-center w-full text-left px-5 py-3 lg:px-4 lg:py-2 text-[1.4vmax] lg:text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium ${PMM?.status === "BLOCKED" ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={PMM?.status === "BLOCKED"}
                                    onClick={() => {
                                        setShowDropdown(false)
                                        setShowPopup(true)
                                        setActionToPerform(PMM.status === "TEMPORARILY_BLOCKED" ? "ACTIVE" : "TEMPORARILY_BLOCKED")
                                        setPopupHeading(`${PMM.status === "TEMPORARILY_BLOCKED" ? "Mark Active" : " Temporarily Block"} ${PMM.name}`)
                                        setPopupPara(PMM.status === "TEMPORARILY_BLOCKED" ?
                                            `Are you sure want to mark ${PMM.name} active again?` :
                                            `Are you sure you want to temporarily block ${PMM.name}? All of their products, pending orders, and active reservations will be suspended until the user is reactivated.`)
                                    }}
                                >
                                    <i className="fa-solid fa-user-clock mr-2 w-4"></i> {PMM?.status === "TEMPORARILY_BLOCKED" ? "Mark Active" : "Block Temporarily"}
                                </button>
                                
                                <button 
                                    className={`flex items-center w-full text-left px-5 py-3 lg:px-4 lg:py-2 text-[1.4vmax] lg:text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium ${PMM?.status === "BLOCKED" ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={PMM?.status === "BLOCKED"}
                                    onClick={() => {
                                        setShowDropdown(false)
                                        setShowApproval(true)
                                    }}
                                >
                                    <i className="fa-solid fa-user-check mr-2 w-4"></i> Approve User
                                </button>

                                {user?.role === "SUPER_ADMIN" && PMM?.status === "PENDING_APPROVAL" && (
                                    <button 
                                        className="flex items-center w-full text-left px-5 py-3 lg:px-4 lg:py-2 text-[1.4vmax] lg:text-[0.75vmax] text-red-600 hover:bg-red-50 font-medium"
                                        onClick={() => {
                                            setShowDropdown(false)
                                            setShowPopup(true)
                                            setActionToPerform("DELETE")
                                            setPopupHeading(`Delete ${PMM.name}`)
                                            setPopupPara(`Are you sure you want to permanently delete ${PMM.name}? This action cannot be undone.`)
                                        }}
                                    >
                                        <i className="fa-solid fa-trash-can mr-2 w-4"></i> Delete User
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showPopup &&
                <section className="fixed inset-0 flex justify-center overflow-y-auto bg-[#ad0c0c6c] z-[9999999999] p-4">
                    <button className="text-[2.5vmax] text-white fixed top-[2vmax] right-[2vmax]"
                        onClick={() => {
                            setShowPopup(false)
                            setActionToPerform("")
                            setPopupHeading("")
                            setPopupPara("")
                        }}
                    >
                        <div className="fa-solid fa-xmark"></div>
                    </button>
                    <div className="w-full max-w-lg bg-white shadow-lg rounded-[2vmax] h-fit mt-[2vmax] overflow-hidden">
                        <h2 className="text-[1.4vmax] font-3 font-[900] text-white p-[0.5vmax_3vmax] bg-[var(--secondary)] mb-[1vmax] text-center" >{popupHeading}</h2>
                        <p className='max-w-[33vmax] p-[0vmax_2vmax_2vmax_2vmax] text-gray-600 font-[600] font-3' >
                            {popupPara}
                        </p>
                        <div className="flex justify-end gap-[1vmax] p-[2vmax] pt-0">
                            <button className="text-[0.9vmax] text-white bg-[image:var(--gradient-3)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => {
                                    setShowPopup(false)
                                    setActionToPerform("")
                                    setPopupHeading("")
                                    setPopupPara("")
                                }}
                            >
                                No, Cancel
                            </button>
                            <button className="text-[0.9vmax] text-white bg-[image:var(--gradient-5)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => handleUpdateStatus(PMM?.id, actionToPerform)}
                            >
                                Yes Proceed
                            </button>
                        </div>
                    </div>
                </section>
            }
            {
                showApproval &&
                <AproveUser setShowApproval={setShowApproval} user={PMM} />
            }
        </Fragment>
    )
}

export default SingleAdmin
